// src/pages/ContactPage.js
import React from "react";
import styles from "../styles/ContactPage.module.css";

function ContactPage() {
  return (
    <div className={styles.contactContainer}>
      <h1 className={styles.title}>Contact Us</h1>
      <div className={styles.contactInfo}>
        {/* 각 정보 줄을 div.infoItem으로 감싸세요 */}
        <div className={styles.infoItem}>
          <span className={styles.infoLabel}>대표 이름:</span>
          <span className={styles.infoValue}>김찬국</span>
        </div>
        <div className={styles.infoItem}>
          <span className={styles.infoLabel}>전화번호:</span>
          <span className={styles.infoValue}>010-9346-0406</span>
        </div>
        <div className={styles.infoItem}>
          <span className={styles.infoLabel}>이메일:</span>
          <span className={styles.infoValue}>kkk1031kkk@naver.com</span>
        </div>
        <p className={styles.inquiryText}>
          문의사항이 있으시면 언제든지 연락 주시기 바랍니다.
        </p>
      </div>
    </div>
  );
}

export default ContactPage;
